import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import ErrorMessage from "../../components/ErrorMessage";
import {BrowserRouter as Router, Redirect} from "react-router-dom";
import {Form, FormCheck, Col, InputGroup, Button, ButtonGroup} from "react-bootstrap";
import {config} from "../../components/Constants";

class ClientsEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            submitError: null,
            isLoaded: true,
            isLoggedIn: false,
            isSubmitting: false,
            redirect: null,
            client: false
        };
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
        this.handleReturn = this.handleReturn.bind(this);
    }

    componentDidMount() {
        fetch(config.API_URL + '/api/clients/edit/' + this.props.match.params.id, {
            credentials: 'include'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            client: null,
                            isLoaded: true,
                            error: result.error
                        });
                    } else if (result) {
                        this.setState({
                            client: result.client,
                            isLoaded: true
                        });
                    }
                },
                (error) => {
                    this.setState({
                        client: null,
                        isLoaded: true,
                        error: error
                    });
                }
            );
    }

    handleSubmitForm(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            isSubmitting: true
        });
        const formData = new FormData(event.target);
        let data = {};
        formData.forEach((val, mkey) => {
            data[mkey] = val;
        });
        fetch(config.API_URL + '/api/clients/update',{
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            'method': 'POST',
            'body': JSON.stringify(data)
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            isSubmitting: false,
                            submitError: result.error
                        });
                    } else if (result) {
                        this.setState({
                            isSubmitting: false,
                            redirect: '/clients'
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isSubmitting: false,
                        submitError: error
                    });
                }
            );
        return false;
    }

    handleReturn(event) {
        if (event && event.preventDefault) {
            event.preventDefault();
        }
        this.setState({
            redirect: '/clients'
        });
        return false;
    }

    render() {
        const {error, isLoaded, isLoggedIn, isSubmitting, submitError, redirect, client} = this.state;
        const that = this;
        if (!isLoaded || client === false) {
            return (
                <LoadingSpin/>
            );
        } else if (redirect !== null) {
            return <Redirect to={redirect}/>
        } else if (client === null) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={'Nie znaleziono obiektu o ID: '+this.props.match.params.id} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', client: {}});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', client: {}});}}/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {'title': 'Powrót', 'callback': function() {that.setState({redirect: '/clients', error: null});}}
                ]} handleClose={() => {that.setState({redirect: '/clients', error: null});}}/>
            );
        } else {
            return (
                <React.Fragment>
                    {isSubmitting ? <LoadingSpin/> : ''}
                    <header className="clients-header">
                        <h1>Edycja obiektu: {client.nazwa}</h1>
                    </header>
                    <div className="section-div">
                        {submitError !== null ? <ErrorMessage title="Pojawiły się błędy" text={submitError} buttons={[
                            {'title': 'OK', 'callback': function() {that.setState({submitError: null});}}
                        ]} handleClose={() => {that.setState({submitError: null});}}/> : ''}
                        <Form method="post" onSubmit={this.handleSubmitForm}>
                            <Form.Control type="hidden" defaultValue={client.id} name="id"/>
                            <h2>Dane podstawowe:</h2>
                            <Form.Row>
                                <Form.Group as={Col} md={6} sm={12} controlId="formGridName">
                                    <Form.Label>
                                        Nazwa obiektu:
                                    </Form.Label>
                                    <Form.Control defaultValue={client.nazwa} name="nazwa" type="text" placeholder="Wprowadź nazwę obiektu" required={true}/>
                                </Form.Group>
                                <Form.Group as={Col} md={6} sm={12} controlId="formGridSubd">
                                    <Form.Label>
                                        Subdomena:
                                    </Form.Label>
                                    <InputGroup>
                                        <InputGroup.Prepend>
                                            <InputGroup.Text id="inputGroupPrepend">https://</InputGroup.Text>
                                        </InputGroup.Prepend>
                                        <Form.Control defaultValue={client.subd} name="subd" type="text" placeholder="Wprowadź subdomenę" required={true}/>
                                        <InputGroup.Append>
                                            <InputGroup.Text id="inputGroupAppend">.sim.horecaidea.pl</InputGroup.Text>
                                        </InputGroup.Append>
                                    </InputGroup>
                                </Form.Group>
                            </Form.Row>
                            <h2>Ustawienia:</h2>
                            <Form.Row>
                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridWeb">
                                    <FormCheck
                                        name="web_aplikacja"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="web_aplikacja" defaultChecked={client.web_aplikacja === 2 ? true : false} defaultValue="2" />
                                    <FormCheck.Label>
                                        <i className="fas fa-globe" title="Web" /> WEB
                                    </FormCheck.Label>
                                    </FormCheck>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridCRM">
                                    <Form.Check
                                        name="czy_crm"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_crm" defaultChecked={client.czy_crm === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label><i className="fas fa-handshake" title="CRM"></i> CRM</FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridEvent">
                                    <Form.Check
                                        name="czy_event"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_event" defaultChecked={client.czy_event === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-star" title="Event"></i> Event
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridManagement">
                                    <Form.Check
                                        name="czy_management"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_management" defaultChecked={client.czy_management === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-chart-line" title="Management"></i> Management
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridMail">
                                    <Form.Check
                                        name="czy_poczta"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_poczta" defaultChecked={client.czy_poczta === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-envelope" title="Comm"></i> Comm
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridMobi">
                                    <Form.Check
                                        name="czy_mobile"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_mobile" defaultChecked={client.czy_mobile === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-mobile-alt" title="Mobile"></i> Mobile
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridCorpo">
                                    <Form.Check
                                        name="czy_corpo"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_corpo" defaultChecked={client.czy_corpo === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-bed" title="Corpo"></i> Corpo
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridVoucher">
                                    <Form.Check
                                        name="czy_voucher"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_voucher" defaultChecked={client.czy_voucher === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-gift" title="Voucher"></i> Voucher
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridHIMedia">
                                    <Form.Check
                                        name="czy_himedia"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_himedia" defaultChecked={client.czy_himedia === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-tv" title="HI Media"></i> Media
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridPlace">
                                    <Form.Check
                                        name="czy_loze"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_loze" defaultChecked={client.czy_loze === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-cubes" title="Place"></i> Place
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridKartaProjektu">
                                    <Form.Check
                                        name="czy_karta_projektu"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_karta_projektu" defaultChecked={client.czy_karta_projektu === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-clipboard-list" title="Production"></i> Production
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridKartaEventu">
                                    <Form.Check
                                        name="czy_karta_eventu"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_karta_eventu" defaultChecked={client.czy_karta_eventu === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fab fa-wpforms" title="Project"></i> Project
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                                <Form.Group as={Col} lg={3} md={6} sm={12} controlId="formGridNajemca">
                                    <Form.Check
                                        name="czy_najemca"
                                        type="switch"
                                    >
                                    <FormCheck.Input name="czy_najemca" defaultChecked={client.czy_karta_eventu === 1 ? true : false} defaultValue="1" />
                                    <FormCheck.Label>
                                    <i className="fas fa-exchange-alt" title="Extranet"></i> Extranet
                                    </FormCheck.Label>
                                    </Form.Check>
                                </Form.Group>

                            </Form.Row>
                            <div className="downbuttons">
                                <Button type="submit" name="submit">Zapisz</Button> <Button onClick={this.handleReturn}>Powrót</Button>
                            </div>
                        </Form>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default ClientsEdit;
